import { useLocation } from "react-router-dom";
import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs";
import {
  useOnboardingAddressListData,
  useOnboardingEDMDetailsData,
  useOnboardingRequestLogsData,
  useOrganizationRecordsListsData,
} from "./hooks/useOnBoard";
import OnboardingAddress from "./OnboardingAddress";
import OnboardingEdmDetails from "./OnboardingEdmDetails";
import OnboardingOrganisationRecord from "./OnboardingOrganisationRecord";
import OnboardingRequestLog from "./OnboardingRequestLog";
import { useState } from "react";
import { Spinner } from "reactstrap";

const OnboardingDetailView = () => {
  const location = useLocation();
  const onboardRequestID = location?.state?.onboardingRequestID;
  const { rowData } = location?.state;

  console.log(
    "🚀 ~ OnboardingDetailView.tsx:21 ~ OnboardingDetailView ~ rowData:",
    rowData
  );

  const [filterAddressState, setFilterAddressState] = useState({
    start: 1,
    length: 10,
  });
  const [filterOrgRecordsState, setFilterOrgRecordsState] = useState({
    start: 1,
    length: 10,
  });
  const [filterOnboardRequestLogsState, setFilterOnboardRequestLogsState] =
    useState({
      start: 1,
      length: 10,
    });
  const { data: EDMDetailsData, isLoading: EDMDetailsLoading } =
    useOnboardingEDMDetailsData({
      id: onboardRequestID,
      enable: !!onboardRequestID,
    });
  const { data: addressListData, isLoading: addressListLoading } =
    useOnboardingAddressListData({
      id: onboardRequestID,
      enable: !!onboardRequestID,
      params: {
        start: filterAddressState?.start,
        length: filterAddressState?.length,
      },
    });

  const {
    data: organizationRecordsData,
    isLoading: organizationRecordsLoading,
  } = useOrganizationRecordsListsData({
    id: onboardRequestID,
    enable: !!onboardRequestID,
    params: {
      start: filterOrgRecordsState?.start,
      length: filterOrgRecordsState?.length,
    },
  });
  const {
    data: onboardingRequestLogsData,
    isLoading: onboardingRequestLogsLoading,
  } = useOnboardingRequestLogsData({
    id: onboardRequestID,
    enable: !!onboardRequestID,
    params: {
      start: filterOnboardRequestLogsState?.start,
      length: filterOnboardRequestLogsState?.length,
    },
  });

  const isLoading =
    !addressListLoading ||
    !organizationRecordsLoading ||
    !onboardingRequestLogsLoading;

  return (
    <div className="p-2">
      {/* Header */}
      <div className="mb-4">
        <PageHeader title="Onboarding Request Detail" />
      </div>

      {/* EDM Details */}
      <div className="mb-4">
        <OnboardingEdmDetails
          EDMDetailsData={EDMDetailsData?.data}
          EDMDetailsLoading={EDMDetailsLoading}
          rowData={rowData}
        />
      </div>

      {/* Address and Organisation */}

      <div className="col-12 mb-4">
        <OnboardingAddress
          addressListData={addressListData}
          setFilterAddressState={setFilterAddressState}
          EDMDetailsData={EDMDetailsData}
        />
      </div>
      <div className="col-12 mb-4">
        <OnboardingOrganisationRecord
          organizationRecordsData={organizationRecordsData}
          setFilterOrgRecordsState={setFilterOrgRecordsState}
        />
      </div>

      {/* Request Log */}
      <div className="col-12 mb-4">
        <OnboardingRequestLog
          onboardingRequestLogsData={onboardingRequestLogsData}
          setFilterOnboardRequestLogsState={setFilterOnboardRequestLogsState}
        />
      </div>
    </div>
  );
};

export default OnboardingDetailView;
